
// import styles from "./HotelGrid.module.css";
// import HotelCard from "./HotelCard";

// export default function HotelGrid({ hotels }) {

//   if (!hotels || hotels.length === 0) {
//     return (
//       <div className={styles.empty}>
//         No hotels available in the selected city.
//       </div>
//     );
//   }

//   return (
//     <section className={styles.wrapper}>

//       <h2 className={styles.heading}>
//         Available Hotels ({hotels.length})
//       </h2>

//       <div className={styles.grid}>
//         {hotels.map((hotel) => (
//           <HotelCard
//             key={hotel.id}
//             hotel={hotel}
//           />
//         ))}
//       </div>

//     </section>
//   );
// }


import styles from "./HotelGridview.module.css";
import HotelCard from "./HotelCard";

export default function HotelGrid({ hotels }) {
  if (!hotels || hotels.length === 0) {
    return (
      <div className={styles.empty}>
        No hotels available in the selected city.
      </div>
    );
  }

  const sortedHotels = [...hotels].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <section className={styles.wrapper}>

      <h2 className={styles.heading}>
        Available Hotels ({sortedHotels.length})
      </h2>

      <div className={styles.grid}>
        {sortedHotels.map((hotel) => (
          <HotelCard
            key={hotel.id}
            hotel={hotel}
          />
        ))}
      </div>

    </section>
  );
}